import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TitleStrategy } from '@angular/router';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'app-find-invoice',
  templateUrl: './find-invoice.component.html',
  styleUrl: './find-invoice.component.scss',
})
export class FindInvoiceComponent implements OnInit {
  inoviceSearchForm: FormGroup;
  invoiceNumberFound: string = '';
  parkerSearchForm: FormGroup;
  companySearchForm: FormGroup;

  constructor(public _appGeneralState: AppGeneralStateService) {
    this.initInvoiceSearchForm();
    this.initParkerSearchForm();
    this.initCompanySearchForm();
  }

  ngOnInit(): void {}

  initInvoiceSearchForm(): void {
    this.inoviceSearchForm = new FormGroup({
      invoiceNumber: new FormControl('', [Validators.maxLength(32), Validators.required]),
    });
  }

  initParkerSearchForm(): void {
    this.parkerSearchForm = new FormGroup({
      lastName: new FormControl('', [Validators.maxLength(32), Validators.required]),
      firstName: new FormControl('', [Validators.maxLength(32), Validators.required]),
    });
  }

  initCompanySearchForm(): void {
    this.companySearchForm = new FormGroup({
      companyName: new FormControl('', [Validators.maxLength(32), Validators.required]),
    });
  }

  onSubmitFindInvoice(): void {
    this.invoiceNumberFound = 'abc';
  }

  onSubmitFindParker(): void {}

  onSubmitFindCompany(): void {}

  onNavToViewInvoice(): void {
    window.open('https://dev.acepark.net/Invoice/ReturnPdf/1004/GB01004112410085', '_blank');
  }
}
